import { faTimes } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { store } from "common/store";

export function TopBar(props) {
    return (
        <>
            <div className="merchant-name" translate="no">
                {store.getState().common.merchant_config.display_name}
                
            </div>
            <div className="page-name">Account settings</div>
            <div className="close-link close-overlay">
                <a href="#" className="close-overlay" onClick={props.closeSettings}>
                    Close settings<FontAwesomeIcon className="close-icon" icon={faTimes} />
                </a>
            </div>
        </>
    );
}
